import { z } from "zod";
import { paginate } from "../pagination.js";
import { contestSchema, priceHistorySchema } from "../schemas/index.js";
export class ContestsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/contests",
            endpoint: "contests.list",
            query: {
                league_id: params.league_id,
                status: params.status,
                q: params.q,
                start_after: params.start_after,
                start_before: params.start_before,
                parent_contest_id: params.parent_contest_id,
                limit: params.limit,
                cursor: params.cursor,
            },
            dataSchema: z.array(contestSchema),
        });
    }
    get(id) {
        return this.http.request({
            method: "GET",
            path: `/contests/${encodeURIComponent(id)}`,
            endpoint: "contests.get",
            dataSchema: contestSchema,
        });
    }
    /**
     * `GET /contests/:id/price-history` — undocumented REST mirror of the MCP
     * `get_contest_price_history` tool. Returns 200 (empty `points`) even for
     * unknown contest ids — see FRICTION.md.
     */
    priceHistory(id, params = {}) {
        return this.http.request({
            method: "GET",
            path: `/contests/${encodeURIComponent(id)}/price-history`,
            endpoint: "contests.priceHistory",
            query: {
                resolution: params.resolution,
                from: params.from,
                to: params.to,
                limit: params.limit,
                position_hash: params.position_hash,
                partner_id: params.partner_id,
            },
            dataSchema: priceHistorySchema,
        });
    }
    /** Async iterator over every contest matching `params`, following cursors. */
    iterate(params = {}) {
        return paginate((cursor) => this.list({ ...params, cursor }));
    }
}
//# sourceMappingURL=contests.js.map